<!--modal header-->
<ion-header>
  <ion-toolbar>
    <ion-title>Customize Profile</ion-title>
  </ion-toolbar>
</ion-header>

<ion-content>
  <div class="ion-padding">
    Here you can <span style="color: #10dc60"><b>select</b></span>, <span style="color: #f04141"><b>unselect</b></span> or <b>reorder</b> pages on your side navigation menu.
  </div>
  <ion-list>
    <!--title of selected pages-->
    <ion-item color="dark" lines="full">
      <ion-icon color="light" slot="start" name="eye"></ion-icon>
      <ion-label>
        <h2>Selected Pages</h2>
      </ion-label>
      <!--page counter-->
      <ion-badge color="light">{{selectedItems.length}}</ion-badge>
    </ion-item>
    <!--reorder group of the pages-->
    <ion-reorder-group (ionItemReorder)="reorderItems($event, selectedItems)" disabled="false">
      <div *ngFor="let item of selectedItems">
        <!--main page-->
        <ion-item lines="full">
          <ion-reorder slot="start"></ion-reorder>
          <ion-icon *ngIf="item.icon" slot="start" name="{{item.icon}}"></ion-icon>
          <ion-label>
            {{item.title}}
          </ion-label>
          <ion-button color="danger" fill="clear" (click)="removeItem(item)">
            <ion-icon slot="icon-only" name="remove"></ion-icon>
          </ion-button>
        </ion-item>
        <!--subpage-->
        <div *ngIf="item.subPages && item.subPages.length > 0">
          <ion-item color="light" lines="none" style="border-bottom:1px solid #DEDEDE"
            *ngFor="let subPage of item.subPages">
            <ion-label>
              {{subPage.title}}
            </ion-label>
            <ion-checkbox slot="end" [(ngModel)]="subPage.display"></ion-checkbox>
          </ion-item>
        </div>
      </div>
    </ion-reorder-group>
  </ion-list>
  <!--unselected pages-->
  <div>
    <ion-list>
      <ion-item color="dark" lines="full">
        <ion-icon color="light" slot="start" name="eye-off"></ion-icon>
        <ion-label>
          <h2>Unselected Pages</h2>
        </ion-label>
        <ion-badge color="light">{{allItems.length}}</ion-badge>
      </ion-item>
      <ion-item lines="full" *ngFor="let item of allItems">
        <ion-icon *ngIf="item.icon" slot="start" name="{{item.icon}}"></ion-icon>
        <ion-label>
          {{item.title}}
        </ion-label>
        <ion-button style="color: #10dc60 !important" fill="clear" (click)="addItem(item)">
          <ion-icon slot="icon-only" name="add"></ion-icon>
        </ion-button>
      </ion-item>
    </ion-list>
  </div>
</ion-content>
<!--modal footer-->
<ion-footer>
  <!--action buttons-->
  <ion-toolbar>
    <ion-button slot="end" (click)="back()" *ngIf="showBack" fill="clear">
      Back
    </ion-button>
    <ion-button slot="end" (click)="cancel()" *ngIf="!showBack" fill="clear">
      Cancel
    </ion-button>
    <ion-button slot="end" (click)="apply()" fill="clear">
      Apply
    </ion-button>
  </ion-toolbar>
</ion-footer>
